export default __webpack_public_path__ + "static/media/mongodb.f9efb4cf.png";